import { Controller } from "@hotwired/stimulus"

class SlideOver extends Controller {
  static targets = ["layout", "slideOver"]
  static classOpen = "-open"
  static classOverlay = "-overlay"

  shouldClose(e) {
    if (this.slideOverTarget.classList.contains(SlideOver.classOpen) && !this.slideOverTarget.contains(e.target)) {
      this.close()
    }
  }

  open(e) {
    e.stopPropagation()
    this.scrollTop()
    this.slideOverTarget.classList.add(SlideOver.classOpen)
    this.layoutTarget.classList.add(SlideOver.classOverlay)
  }

  close() {
    this.slideOverTarget.classList.remove(SlideOver.classOpen)
    this.layoutTarget.classList.remove(SlideOver.classOverlay)
  }

  scrollTop() {
    this.slideOverTarget.scrollTop = 0
  }
}

export { SlideOver }
